
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.$router.beforeEach((to: Route, from: Route, next: Function) => {
    // Removes overflow hidden caused by useModal / useDialog
    document.body.style.overflow = 'auto';
    next();
  });
});
